import React from 'react';

interface BillingPeriodToggleProps {
    billingPeriod: string;
    setBillingPeriod: (period: string) => void;
}

const BillingPeriodToggle: React.FC<BillingPeriodToggleProps> = ({
    billingPeriod,
    setBillingPeriod,
}) => {
    return (
        <div className="flex justify-center">
            <div className="relative bg-accent-sand rounded-lg p-1 flex">
                <button
                    onClick={() => setBillingPeriod('monthly')}
                    className={`relative px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 ${billingPeriod === 'monthly'
                        ? 'bg-white text-secondary-600 shadow-sm'
                        : 'text-text-description hover:text-text-heading'
                        }`}
                >
                    Solo
                </button>
                <button
                    onClick={() => setBillingPeriod('4month')}
                    className={`relative px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 ${billingPeriod === '4month'
                        ? 'bg-white text-secondary-600 shadow-sm'
                        : 'text-text-description hover:text-text-heading'
                        }`}
                >
                    Team
                    <span className="ml-1 inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        15% OFF
                    </span>
                </button>
                <button
                    onClick={() => setBillingPeriod('yearly')}
                    className={`relative px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 ${billingPeriod === 'yearly'
                        ? 'bg-white text-secondary-600 shadow-sm'
                        : 'text-text-description hover:text-text-heading'
                        }`}
                >
                    Organization
                    <span className="ml-1 inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        20% OFF
                    </span>
                </button>
            </div>
        </div>
    );
};

export default BillingPeriodToggle;
